import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
const SvgPlus = (props, ref) => /* @__PURE__ */ jsx("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props, children: /* @__PURE__ */ jsx("path", { d: "M13 4H11V11L4 11V13H11V20H13V13H20V11L13 11V4Z", fill: "currentColor" }) });
const ForwardRef = forwardRef(SvgPlus);
export { ForwardRef as ReactComponent };
